import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    TypedBaseListComponent,
    SharedModule,
    ModalService,
    NotificationService,
} from '@vendure/admin-ui/core';
import { GetTimeSlotsDocument } from '../../generated-types';
import { BulkTimeSlotModalComponent } from '../bulk-create-modal/bulk-create-modal.component';

@Component({
    selector: 'time-slot-list',
    templateUrl: './time-slot-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SharedModule],
})
export class TimeSlotListComponent extends TypedBaseListComponent<typeof GetTimeSlotsDocument, 'timeSlots'> {
    readonly filters = this.createFilterCollection()
        .addIdFilter()
        .addDateFilters()
        .connectToRoute(this.route);

    readonly sorts = this.createSortCollection()
        .defaultSort('date', 'DESC')
        .addSort({ name: 'date' })
        .addSort({ name: 'createdAt' })
        .addSort({ name: 'updatedAt' });

    constructor(
        private modalService: ModalService,
        private notificationService: NotificationService,
    ) {
        super();
        super.configure({
            document: GetTimeSlotsDocument,
            getItems: data => data.timeSlots,
            setVariables: (skip, take) => ({
                options: {
                    skip,
                    take,
                    filter: {
                        ...this.filters.createFilterInput(),
                    },
                },
            }),
            refreshListOnChanges: [this.filters.valueChanges, this.sorts.valueChanges],
        });
    }

    openBulkTimeSlotModal() {
        this.modalService
            .fromComponent(BulkTimeSlotModalComponent, {
                closable: true,
            })
            .subscribe(result => {
                if (result) {
                    this.notificationService.success('Bulk time slots created successfully');
                    this.refresh();
                }
            });
    }

    fromUtcDateOnly(utcDateString: string): string {
        if (!utcDateString) return utcDateString;

        const [year, month, day] = utcDateString.split('-').map(Number);
        const utcDate = new Date(Date.UTC(year, month - 1, day));

        const localYear = utcDate.getFullYear();
        const localMonth = String(utcDate.getMonth() + 1).padStart(2, '0');
        const localDay = String(utcDate.getDate()).padStart(2, '0');

        return `${localYear}-${localMonth}-${localDay}`;
    }
}
